export const reportDiscountsRelationshipTypes = {
  SET_DISCOUNTS_RELATIONSHIP_FILTERS: 'SET_DISCOUNTS_RELATIONSHIP_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};
